const settings = {
  state: {
    screenLoading: false,
    uploadImgUrl: '/homepage_admin/common/oss',
    uploadFileUrl: '/homepage_admin/common/file/to/oss'
  },
  mutations: {
    SET_SCREEN_LOADING (state, screenLoading) {
      state.screenLoading = screenLoading;
    }
  },
  actions: {}
};

export default settings;
